import { VisitSession } from '@va/dashboard/api-client/Visitors';
import { DataTableV8 } from '@va/ui/components/data-table';
import { useRefreshContext } from '@va/util/components';
import useVisitorHistoryContext from './VisitorHistoryContext';
import { useVisitorsHistoryColumns } from './useVisitorsHistoryColumns';

const VisitorsHistoryTable = () => {
  const { isLoading, data: visitorHistoryResponse } = useVisitorHistoryContext();
  const { isManualRefreshing } = useRefreshContext();
  const isInProgress = isLoading || isManualRefreshing;
  const columns = useVisitorsHistoryColumns();

  return (
    <DataTableV8<VisitSession>
      id='visitors-history'
      minWidth={1300}
      columns={columns}
      data={isInProgress ? [] : visitorHistoryResponse ?? []}
      isLoading={isInProgress}
      disablePagination
    />
  );
};

export default VisitorsHistoryTable;
